import { Fragment } from "react";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FormattedMessage } from "react-intl";
import { NavLink } from "react-router-dom";
import { formatText } from "util/helper";
import classes from "./ChildMenu.module.css";

const ChildMenu = ({ childItem, closeChildMenuHandler }) => {
  return (
    <Fragment>
      <li className={classes["child-menu-list"]}>
        <NavLink
          to={childItem.url}
          activeClassName={classes.active}
          onClick={() => closeChildMenuHandler()}
        >
          <FormattedMessage id={formatText(childItem.title)} />
          <span className={classes["right-arrow"]}>
            <FontAwesomeIcon icon={faChevronRight} />
          </span>
        </NavLink>
      </li>
    </Fragment>
  );
};

export default ChildMenu;
